import {createApp} from 'vue';
import App from './App.vue';
import store from './store';

/* eslint-disable no-unused-vars */
import "@/assets/fonts.css";
import "@/assets/tooltip.css"; // global styles
import "@/assets/fade.css"; // global styles
/* eslint-enable no-unused-vars */

const startApp = async () => {
    
    const app = createApp(App);
    app.use(store);

    try {
        store.dispatch('initializeAppState'); //not necessary to await
        
    } catch (e) {
        console.error("Can't load the state, while loading the app:", e);
    }

    
    app.mount('#app');
};

startApp();